module.exports = new __parcel__URL__("mainframe_level_2_v2.526c27c3.png").toString();